import React from 'react'

import headerStyles from '../styles/header.module.scss'
import '../styles/button.scss'
import Nav from './nav'


const Header = () => {

    return(

        
        <header className={headerStyles.header}> 
            <Nav />
        </header>
    )
}

export default Header